// @flow
import i18n from 'i18n-js';

import * as userActions from '../../actions/users';
import {
  DRIVER_RESULT_TYPE,
  STUDENT_RESULT_TYPE,
} from '../UserSearchResult/types';
import { phoneIsValid } from '../../utils';

function emailIsValid(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export const validateContact = (
  {
    first_name,
    last_name,
    email,
    phone,
  },
) => {
  const errorStatus = {
    canSave: true,
    errors: {},
  };
  if (first_name === '') {
    errorStatus.canSave = false;
    errorStatus.errors.first_name = i18n.t('labels.requiredField');
  }
  if (last_name === '') {
    errorStatus.canSave = false;
    errorStatus.errors.last_name = i18n.t('labels.requiredField');
  }
  if (!emailIsValid(email)) {
    errorStatus.canSave = false;
    errorStatus.errors.email = i18n.t('labels.requiredField');
  }
  if (!phoneIsValid(phone)) {
    errorStatus.canSave = false;
    errorStatus.errors.phone = i18n.t('labels.requiredField');
  }

  return errorStatus;
}

export const validate = (values: Object) => {
  const {
    user_profile,
    first_name,
    last_name,
    phone,
    email,
    address,
    code,
    license_type,
    stops_scheduling_going,
    stops_scheduling_returning,
    complex_address,
  } = values;

  const errors = {};

  if (!user_profile) {
    errors.user_profile = i18n.t('labels.requiredField');
  }

  if (!first_name) {
    errors.first_name = i18n.t('labels.requiredField');
  }

  if (!last_name) {
    errors.last_name = i18n.t('labels.requiredField');
  }

  if (!phone) {
    errors.phone = i18n.t('labels.requiredField');
  }

  if (!email) {
    errors.email = i18n.t('labels.requiredField');
  }

  if (!address) {
    errors.address = i18n.t('labels.requiredField');
  }

  if (
    !complex_address
  ) {
    errors.complex_address = i18n.t('labels.requiredField');
  }  else if (
    (!complex_address.address1 || complex_address.address1 === '')
    || (!complex_address.address2 || complex_address.address2 === '')
    || (!complex_address.address3 || complex_address.address3 === '')
    || (!complex_address.address4 || complex_address.address4 === '')
    || (!complex_address.address5 || complex_address.address5 === '')
  ) {
    errors.complex_address = i18n.t('labels.requiredField');
  }

  if (!license_type && user_profile === DRIVER_RESULT_TYPE) {
    errors.code = i18n.t('labels.requiredField');
  }

  if (!emailIsValid(email)) {
    errors.email = i18n.t('labels.validEmail');
  }

  if (user_profile === 'student_profile') {
    if (!!stops_scheduling_going) {
      Object.values(stops_scheduling_going).forEach((stop) => {
        if (!stop.week_days || stop.week_days.length === 0) {
          errors.stops_scheduling_going = i18n.t('labels.validStopsWeekDays');
        }
      });
    }

    if (!!stops_scheduling_returning) {
      Object.values(stops_scheduling_returning).forEach((stop) => {
        if (!stop.week_days || stop.week_days.length === 0) {
          errors.stops_scheduling_returning = i18n.t('labels.validStopsWeekDays');
        }
      });
    }
  }

  return errors;
};

export const updateUser = (values: Object, dispatch: Function) => {
  dispatch(
    userActions.updateUserStart(
      values,
    ),
  );
};

export const removeUser = (userId: ID_TYPE, resultType: string, dispatch: Function) => {
  dispatch(
    userActions.removeUserStart(
      userId,
      userId,
      resultType,
    ),
  );
};

export const onSubmit = (values: Object, dispatch: Function, _props: Object) => {
  const {
    profile_picture,
    user_profile,
    first_name,
    last_name,
    phone,
    email,
    address,
    complex_address,
    code,
    license_type,
    parents,
    stops_scheduling_going,
    stops_scheduling_returning,
    isContact,
  } = values;

  dispatch(userActions.addUserStart(
    profile_picture,
    user_profile,
    first_name,
    last_name,
    phone,
    code || '',
    email,
    license_type,
    address,
    complex_address,
    parents,
    stops_scheduling_going,
    stops_scheduling_returning,
    isContact,
  ));
};

export const rowsDefinition = [
  {
    accessName: 'id',
    componentType: 'hidden',
  },
  {
    placeholder: '',
    accessName: 'profilepic',
    componentType: 'image',
  },
  {
    placeholder: 'Name',
    accessName: 'first_name',
    componentType: 'text',
    canEdit: true,
    highlight: true,
  },
  {
    placeholder: 'Surname',
    accessName: 'last_name',
    componentType: 'text',
    canEdit: true,
    highlight: true,
  },
  {
    placeholder: 'Email',
    accessName: 'email',
    componentType: 'text',
    canEdit: true,
    error: '',
  },
  {
    placeholder: 'Phone',
    accessName: 'phone',
    componentType: 'text',
    canEdit: true,
  },
];



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUserForm/utils.js